/* cookie-banner.js — bottom-bar consent banner with Consent Mode V2 hook.
 *
 * Consent Mode V2 hook (placeholder):
 *   gtag('consent', 'update', {
 *     ad_storage: 'denied',
 *     analytics_storage: status === 'accepted' ? 'granted' : 'denied'
 *   });
 *   Listen with: document.addEventListener('kosho:consent', e => { /* gtag call *\/ });
 *
 * Spec: prompt brief + Docs/機能要件定義書.md §4.1.4.
 *  - On DOMContentLoaded: read kosho_cookie_consent cookie.
 *      If present → do nothing.
 *      If absent  → render banner at bottom and slide up.
 *  - "Accept":  set cookie =accepted, slide down, dispatch CustomEvent('kosho:consent', {detail:{status:'accepted'}}).
 *  - "Decline": set cookie =declined, slide down, dispatch CustomEvent with status:'declined'.
 *
 * Public API:
 *   window.KoshoCookieBanner.show()
 *   window.KoshoCookieBanner.hide()
 *   window.KoshoCookieBanner.reset()  — delete cookie + reload (dev helper)
 *   window.KoshoCookieBanner.status() — returns 'accepted' | 'declined' | null
 */

(function (global) {
  'use strict';

  var COOKIE_NAME = 'kosho_cookie_consent';
  var COOKIE_MAX_AGE = 60 * 60 * 24 * 365; // 1 year

  var MOUNT_SELECTOR = '#cookie-banner-root';

  var rootEl = null;
  var isOpen = false;

  function readCookie(name) {
    var match = document.cookie.match(new RegExp('(?:^|;\\s*)' + name + '=([^;]*)'));
    return match ? decodeURIComponent(match[1]) : null;
  }

  function writeCookie(name, value, maxAgeSec) {
    document.cookie = name + '=' + encodeURIComponent(value) +
      '; path=/; max-age=' + maxAgeSec + '; samesite=lax';
  }

  function deleteCookie(name) {
    document.cookie = name + '=; path=/; max-age=0; samesite=lax';
  }

  function buildMarkup() {
    return '' +
      '<div class="cookie-banner__inner">' +
        '<p class="cookie-banner__text">' +
          'We use cookies to enhance your experience. By accepting, you agree to ' +
          'our use of cookies for analytics and personalization. ' +
          '<a href="/legal/privacy.html">Learn more</a>' +
        '</p>' +
        '<div class="cookie-banner__actions">' +
          '<button type="button" class="cookie-banner__btn cookie-banner__btn--decline" data-cookie-decline>' +
            'Decline' +
          '</button>' +
          '<button type="button" class="cookie-banner__btn cookie-banner__btn--accept" data-cookie-accept>' +
            'Accept' +
          '</button>' +
        '</div>' +
      '</div>';
  }

  function ensureMounted() {
    if (rootEl) return;
    var mount = document.querySelector(MOUNT_SELECTOR);
    rootEl = document.createElement('div');
    rootEl.className = 'cookie-banner';
    rootEl.setAttribute('role', 'region');
    rootEl.setAttribute('aria-label', 'Cookie consent');
    rootEl.setAttribute('hidden', '');
    rootEl.innerHTML = buildMarkup();
    if (mount) {
      mount.appendChild(rootEl);
      mount.removeAttribute('hidden');   /* wrapper had `hidden`, which kept the bar at 0 height; rootEl's own hidden/is-open now governs visibility */
    } else {
      document.body.appendChild(rootEl);
    }
    bindInternal();
  }

  function bindInternal() {
    rootEl.addEventListener('click', function (e) {
      var t = e.target;
      if (t.closest && t.closest('[data-cookie-accept]')) {
        accept();
        return;
      }
      if (t.closest && t.closest('[data-cookie-decline]')) {
        decline();
        return;
      }
    });
  }

  function show() {
    ensureMounted();
    if (isOpen) return;
    isOpen = true;
    rootEl.removeAttribute('hidden');
    /* eslint-disable-next-line no-unused-expressions */
    rootEl.offsetHeight;
    rootEl.classList.add('is-open');
  }

  function hide() {
    if (!isOpen || !rootEl) return;
    isOpen = false;
    rootEl.classList.remove('is-open');
    setTimeout(function () {
      if (!isOpen && rootEl) rootEl.setAttribute('hidden', '');
    }, 320);
  }

  function emit(status) {
    try {
      var ev = new CustomEvent('kosho:consent', { detail: { status: status } });
      document.dispatchEvent(ev);
    } catch (err) {
      // IE11 fallback (very unlikely target, but safe)
      var legacy = document.createEvent('CustomEvent');
      legacy.initCustomEvent('kosho:consent', false, false, { status: status });
      document.dispatchEvent(legacy);
    }
  }

  function accept() {
    writeCookie(COOKIE_NAME, 'accepted', COOKIE_MAX_AGE);
    hide();
    emit('accepted');
  }

  function decline() {
    writeCookie(COOKIE_NAME, 'declined', COOKIE_MAX_AGE);
    hide();
    emit('declined');
  }

  function status() {
    return readCookie(COOKIE_NAME);
  }

  function reset() {
    deleteCookie(COOKIE_NAME);
    location.reload();
  }

  function init() {
    if (readCookie(COOKIE_NAME)) return; // already set (accepted or declined)
    ensureMounted();
    // Tiny delay so age-gate has rendered first if both fire same tick.
    setTimeout(show, 200);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  global.KoshoCookieBanner = {
    show: show,
    hide: hide,
    reset: reset,
    status: status
  };
})(window);
